var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 598,
    viewBox: "0 0 472 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.81 0C312.221 24.4682 305.678 48.8911 299.089 73.3592C224.317 133.648 149.545 193.981 74.7723 254.27L341.149 349.248L172.911 484.931L200.95 417.089C219.644 400.491 238.337 383.938 257.03 367.339C171.369 335.68 85.661 304.02 0 272.361C106.27 181.589 212.54 90.7719 318.81 0Z",
    fill: "#476072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.19 598C159.779 573.532 166.322 549.109 172.911 524.641C247.683 464.352 322.455 404.019 397.228 343.73C308.436 312.071 219.644 280.411 130.851 248.752C186.931 203.524 243.01 158.297 299.089 113.069L271.05 180.911C252.356 197.509 233.663 214.062 214.97 230.661C300.631 262.32 386.339 293.98 472 325.639C365.73 416.411 259.46 507.228 153.19 598Z",
    fill: "#476072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.9426f4fabb119a0675f6670a0c8883e8.svg";
export { ForwardRef as ReactComponent };